export default [
  /*** 学长管理 开始 ***/
  {
    path: '/senior/list',
    component: () => import('../pages/senior/senior/index.vue'),
    meta: { title: '学长管理' }
  },
  {
    path: '/senior/list/detail/:seniorId',
    component: () => import('../pages/senior/senior/detail.vue'),
    meta: { title: '学长详情' }
  },
  /*** 学长管理 结束 ***/

   /*** 学长服务 开始 ***/
  {
    path: '/senior/service',
    component: () => import('../pages/senior/service/index.vue'),
    meta: { title: '学长服务' }
  },
  /*** 学长服务 结束***/
  /*** 申请管理 开始 ***/
  {
    path: '/senior/apply',
    component: () => import('../pages/senior/apply/index.vue'),
    meta: { title: '认证申请' }
  },
  {
    path: '/senior/topicMangement',
    component: () => import('../pages/senior/topicMangement/index.vue'),
    meta: { title: '专题管理' }
  },
   {
    path: '/senior/topicCreate',
    component: () => import('../pages/senior/topicMangement/create.vue'),
    meta: { title: '专题创建' }
  },
   {
    path: '/senior/topicEdit/:editId',
    component: () => import('../pages/senior/topicMangement/edit.vue'),
    meta: { title: '专题编辑' }
  },
   {
    path: '/senior/communicate',
    component: () => import('../pages/senior/communicate/index.vue'),
    meta: { title: '学长沟通' }
  },
  {
    path: '/senior/apply/detail/:seniorId',
    component: () => import('../pages/senior/apply/detail.vue'),
    meta: { title: '认证详情' }
  },
   {
    path: '/senior/userMange',
    component: () => import('../pages/senior/userMange/index.vue'),
    meta: { title: '笔记用户管理' }
  },
  {
    path: '/senior/problemsSuggestion',
    component: () => import('../pages/senior/problemsSuggestion/index.vue'),
    meta: { title: '问题与建议' }
  },
  /*** 申请管理 结束 ***/

  /*** 提现管理 开始 ***/
  {
    path: '/senior/withdraw',
    component: () => import('../pages/senior/withdraw/index.vue'),
    meta: { title: '提现管理' }
  },
  /*** 提现管理 结束 ***/

  /*** 订单管理 开始 ***/
  {
    path: '/senior/order',
    component: () => import('../pages/senior/order/index.vue'),
    meta: { title: '订单管理' }
  },
  /*** 订单管理 结束 ***/

  /*** 学长费率 开始 ***/
  {
    path: '/senior/charge',
    component: () => import('../pages/senior/charge/index.vue'),
    meta: { title: '学长费率' }
  },
  /*** 学长费率 结束 ***/

  /*** 收益分成 开始 ***/
  {
    path: '/senior/profit', 
    component: () => import('../pages/senior/profit/index.vue'),
    meta: { title: '收益分成' }
  },
  /*** 收益分成 结束 ***/


  /*** 任务大厅 开始 ***/
  {
    path: '/senior/task',
    component: () => import('../pages/senior/task/index.vue'), 
    meta: { title: '任务大厅' }
  },
  {
    path: '/senior/experience',
    component: () => import('../pages/senior/experience/index.vue'), 
    meta: { title: '学长经验' }
  },
  {
    path: '/senior/comment',
    component: () => import('../pages/senior/comment/index.vue'), 
    meta: { title: '学长评论' }
  },
  {
    path: '/senior/noteMange',
    component: () => import('../pages/senior/noteMange/index.vue'), 
    meta: { title: '笔记管理' }
  },
   {
    path: '/senior/randomComment',
    component: () => import('../pages/senior/randomComment/index.vue'), 
    meta: { title: '笔记管理评论' }
  },
   {
    path: '/senior/orderMange',
    component: () => import('../pages/senior/orderMange/index.vue'), 
    meta: { title: '订单管理' }
  },
  {
    path: '/senior/noteMange/editNote/:id',
    component: () => import('../pages/senior/noteMange/edit.vue'), 
    meta: { title: '笔记编辑' }
  },
   {
    path: '/senior/noteComment',
    component: () => import('../pages/senior/noteComment/index.vue'), 
    meta: { title: '笔记评论' }
  },
   {
    path: '/senior/shareStatistics',
    component: () => import('../pages/senior/shareStatistics/index.vue'), 
    meta: { title: '分享统计' }
  },
  {
    path: '/senior/message',
    component: () => import('../pages/senior/message/index.vue'), 
    meta: { title: '学长信息' }
  },
  {
    path: '/senior/edit/:articleId',
    component: () => import('../pages/content/article/senior.vue'),
    meta: { title: '信息资讯编辑' }
  },
  {
    path: '/senior/task/:id',
    component: () => import('../pages/senior/task/detail.vue'),
    meta: { title: '任务大厅详情' }
  }, 
  /*** 任务大厅 结束 ***/

]
